module.exports = __webpack_public_path__ + "static/media/englishPage3.3a430202.jpg";